import React from "react";
import DocumentNavbar from "./DocumentNavbar";
function DocumentTelecallerHome() {
    return(
        <>
        <DocumentNavbar />
        <div className="card" style={{backgroundColor:'gainsboro',position:'relative',top:'50px'}}>
            <h2 >Document Telecaller Home</h2>
        </div>
        </>
    );
}
export default DocumentTelecallerHome;